<template>
  <div class="dialog-modal" v-if="isShow" @click="hide">
    <div class="dialog-content" v-if="options.list && options.list[0]">
      <div class="dialog-title" v-if="options.title">{{options.title}}</div>
      <div class="dialog-item" v-for="(item, index) in options.list" @click="select(item)" :key="index">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Select",
  data() {
    return {
      options: {},
      isShow: false
    };
  },
  mounted() {

  },
  methods: {
    show(options) {
      this.options = options
      this.isShow = true
    },
    hide() {
      this.isShow = false
    },
    select(item) {
      this.options.select && this.options.select(item)
    }
  }
};
</script>


<style scoped lang="scss">
.dialog-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
  .dialog-title {
    font-size: 18px;
    color: #333;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
  }
  .dialog-content {
    background-color: #FFF;
    margin: 100px auto;
    border-radius: 8px;
    width: 350px;
    padding: 0;
    box-shadow: 0 5px 15px rgba(0,0,0,.2);
    .dialog-item {
      border-bottom: 1px solid #d8d8d8;
      cursor: pointer;
      text-align: center;
      font-size: 15px;
      color: #333;
      padding: 15px;
      margin: 0 auto;
    }
    .dialog-item:last-child {
      border-bottom: 0px solid #d8d8d8;
    }
  }
}
</style>


